import { render, staticRenderFns } from "./CollectionSummary.vue?vue&type=template&id=e731f37a"
import script from "./CollectionSummary.vue?vue&type=script&lang=js"
export * from "./CollectionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports